// < Pattern
let pattern_1 = '<svg width="1920" height="41" viewBox="0 0 1920 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M1920 36.9517L1920 41.0005L-7.64349e-06 41.0002L-6.87232e-06 36.8636C253.87 13.9511 590.37 9.75299e-05 959.5 0.000158062C1329.12 -0.00344206 1666.01 13.9843 1920 36.9517Z" fill="#ffffff"/></svg>\n';
let pattern_2 = '<svg width="1920" height="41" viewBox="0 0 1920 41" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M3.44436e-06 4.04892L3.82176e-06 0.000151566L1920 0.00030899L1920 4.13693C1666.13 27.0494 1329.63 41.0004 960.5 41.0004C590.88 41.004 253.99 27.0164 3.44436e-06 4.04892Z" fill="#fff"/></svg>\n';
let pattern_3 = '<svg width="134" height="128" viewBox="0 0 134 128" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M0 126.907C5.07355 127.628 10.2473 128 15.5 128C74.4977 128 123.537 81.1918 132.489 20.1896C133.523 13.5105 134.028 6.75941 133.999 0H90.3527C90.3527 44.7133 56.7732 80.8307 15.5 80.8307C10.1875 80.8307 5.0024 80.2299 0 79.088V126.907Z" fill="#F7A600"/></svg>\n'
let pattern_4 = '<svg width="134" height="128" viewBox="0 0 134 128" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M134 126.907C128.926 127.628 123.753 128 118.5 128C59.5023 128 10.4635 81.1918 1.51137 20.1896C0.476974 13.5105 -0.0281067 6.75941 0.00120544 0H43.6473C43.6473 44.7133 77.2268 80.8307 118.5 80.8307C123.813 80.8307 128.998 80.2299 134 79.088V126.907Z" fill="#F7A600"/></svg>';

function patternBgColor(parent,block){
  if (jQuery(parent).hasClass('bg-color-1')) {
    block.addClass('block-pattern-bg-color-1');
  }
  else if (jQuery(parent).hasClass('bg-color-2')) {
    block.addClass('block-pattern-bg-color-2');
  }
  else if (jQuery(parent).hasClass('bg-color-3')) {
    block.addClass('block-pattern-bg-color-3');
  }
  else if (jQuery(parent).hasClass('bg-color-4')) {
    block.addClass('block-pattern-bg-color-4');
  }
  else if (jQuery(parent).hasClass('bg-color-5')) {
    block.addClass('block-pattern-bg-color-5');
  }
}

jQuery(document).ready(function() {

  jQuery('.pattern-left').each(function () {
    let block = jQuery('<div class="block-pattern block-pattern-left">' + pattern_3 + '</div>').prependTo(jQuery(this));

    jQuery(this)
        .css('overflow', 'visible')
        .css('position', 'relative');

    if (jQuery(this).hasClass('pattern-left-middle')) {
      block.addClass('block-pattern-left-middle');
    }
    else if (jQuery(this).hasClass('pattern-left-bottom')) {
      block.addClass('block-pattern-left-bottom');
    }
    else if (jQuery(this).hasClass('pattern-left-bottom-with-padding')) {
      block.addClass('block-pattern-left-bottom-with-padding');
    }
  });

  jQuery('.pattern-right').each(function () {
    let block = jQuery('<div class="block-pattern block-pattern-right">' + pattern_4 + '</div>').prependTo(jQuery(this));

    jQuery(this)
        .css('overflow', 'visible')
        .css('position', 'relative');

    if (jQuery(this).hasClass('pattern-right-middle')) {
      block.addClass('block-pattern-right-middle');
    }
    else if (jQuery(this).hasClass('pattern-right-bottom')) {
      block.addClass('block-pattern-right-bottom');
    }
    else if (jQuery(this).hasClass('pattern-right-bottom-with-padding')) {
      block.addClass('block-pattern-right-bottom-with-padding');
    }
  });

  jQuery('.pattern-before').each(function () {
    let block = jQuery('<div class="block-pattern block-pattern-before">'+ pattern_1 +'</div>').prependTo(jQuery(this));
    let height = block.height();

    jQuery(this)
        .css('overflow', 'visible')
        .css('position', 'relative');

    if( !jQuery(this).hasClass('pattern-before-no-margin') )
      jQuery(this).css('margin-top', height);

    patternBgColor(jQuery(this),block);
  });

  jQuery('.pattern-after').each(function () {
    let block = jQuery('<div class="block-pattern block-pattern-after">'+ pattern_2 +'</div>').appendTo(jQuery(this));
    let height = block.height();

    jQuery(this).css('overflow', 'visible');
    jQuery(this).css('position', 'relative');

    if( !jQuery(this).hasClass('pattern-after-no-margin') )
      jQuery(this).css('margin-bottom', height);

    patternBgColor(jQuery(this),block);
    jQuery(this).nextAll('.vc_row').first().addClass('pattern-after__next-cv-row');
  });
  
});
// >